// extracted by mini-css-extract-plugin
module.exports = {"container":"Faq_container__D40Gy","heading":"Faq_heading__CW0lJ","intro":"Faq_intro__dET7c","questions":"Faq_questions__Fjjcb","question":"Faq_question__G4HXj"};